import React from 'react'
import Tooltip from './components/Tooltip'

class TextInput extends React.Component {
    static getDerivedStateFromProps(props, state) {
        if (state.prevPropValue !== props.value) {
            return {
                prevPropValue: props.value,
                value: props.value || '',
            }
        }
        return {}
    }

    constructor(props) {
        super(props)
        this.state = {
            value: this.props.value ? this.props.value : '',
            prevPropValue: this.props.value,
            isValid: true,
        }
    }

    onChange = evt => {
        const { onUpdate, name, id, payload, schema } = this.props

        const value = evt.target.value

        this.setState({
            value,
            isValid: false,
        })

        if (schema.payload && schema.payload.controlType) {
            if (schema.payload.controlType === 'number') {
                const { min, max } = schema
                if (typeof min === 'number' && value < min) return
                if (typeof max === 'number' && value > max) return
            }
        }

        this.setState({
            isValid: true,
        })

        onUpdate(id, { [name]: value }, payload)
    }

    render() {
        const {
            tooltipText,
            descriptionText,
            schema: { label = '', payload },
        } = this.props
        const { value, isValid } = this.state

        return (
            <div className="control-box">
                {label.length ? (
                    <p className="label">
                        {label}
                        {<Tooltip tooltipText={tooltipText} />}
                    </p>
                ) : null}
                <div className="content input">
                    <input
                        className={`text ${!isValid ? 'is-error' : ''}`}
                        type={payload && payload.controlType ? payload.controlType : 'text'}
                        value={value}
                        onChange={this.onChange}
                    />
                </div>
                {descriptionText ? <p className="description">{descriptionText}</p> : null}
            </div>
        )
    }
}

export default TextInput
